import React, { useState } from 'react';
import './App.css';
import PasscodeScreen from './components/PasscodeScreen';
import Gallery from './components/Gallery';
import loadMediaData from './data/mediaData';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [mediaByYear, setMediaByYear] = useState({});
  const [yearDescriptions, setYearDescriptions] = useState({});
  const [loading, setLoading] = useState(false);

  const PASSCODE = 'biochimiste';

  const handlePasscodeSubmit = (passcode) => {
    if (passcode === PASSCODE) {
      setIsAuthenticated(true);
      loadMedia();
    } else {
      return false;
    }
  };

  const loadMedia = async () => {
    setLoading(true);
    try {
      // Load media data using the mediaData module
      // This reads mediaData.json and uses require.context() to find all files
      const data = await loadMediaData();
      
      // Store descriptions separately
      const descriptions = {};
      
      // Process the data to organize files by year
      const processedData = {};
      Object.entries(data).forEach(([year, yearData]) => {
        // Store the description for this year
        if (yearData.description) {
          descriptions[year] = yearData.description;
        }
        
        // Only add years that have files
        if (yearData.files && yearData.files.length > 0) {
          // Convert file paths to media objects
          processedData[year] = yearData.files.map(fileUrl => {
            const filename = fileUrl.split('/').pop();
            const fileInfo = parseFilename(filename);

            return {
              url: fileUrl,
              name: filename,
              type: fileInfo.type,
              date: fileInfo.date,
              time: fileInfo.time,
              isVideo: !!filename.toLowerCase().match(/\.(mp4|webm|mov|avi|mkv)$/i),
              isDocument: !!filename.toLowerCase().match(/\.(pdf|doc|docx|txt)$/i),
            };
          });
        }
      });

      setMediaByYear(processedData);
      setYearDescriptions(descriptions);
    } catch (error) {
      console.error('Error loading media:', error);
    } finally {
      setLoading(false);
    }
  };

  const parseFilename = (filename) => {
    // Try to parse WhatsApp format first
    // Pattern: "WhatsApp Image 2025-01-27 at 2.17.45 PM.jpeg"
    const match = filename.match(
      /WhatsApp\s+(Image|Video|Document)\s+(\d{4})-(\d{2})-(\d{2})\s+at\s+(.+?)\.(jpeg|jpg|png|mp4|webm|mov|gif|pdf|doc|docx|txt)$/i
    );

    if (match) {
      const type = match[1];           // "Image", "Video", or "Document"
      const year = match[2];           // "2025"
      const month = match[3];          // "01"
      const day = match[4];            // "27"
      const time = match[5];           // "2.17.45 PM"

      // Create formatted date
      const dateObj = new Date(year, month - 1, day);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });

      return {
        type: type,
        date: formattedDate,
        time: time,
      };
    }

    // Fallback for regular filenames (if not WhatsApp format)
    const lowerFilename = filename.toLowerCase();
    let type = 'File';
    if (lowerFilename.match(/\.(jpg|jpeg|png|gif|webp)$/i)) type = 'Image';
    else if (lowerFilename.match(/\.(mp4|webm|mov|avi|mkv)$/i)) type = 'Video';
    else if (lowerFilename.match(/\.(pdf|doc|docx)$/i)) type = 'Document';

    return {
      type: type,
      date: 'Unknown',
      time: '',
    };
  };

  if (!isAuthenticated) {
    return <PasscodeScreen onSubmit={handlePasscodeSubmit} />;
  }

  return (
    <Gallery
      mediaByYear={mediaByYear}
      yearDescriptions={yearDescriptions}
      loading={loading}
    />
  );
};

export default App;
